// extracted by mini-css-extract-plugin
export default {"box":"Box_box__rbdR8","wrap":"Box_wrap__3++Pv"};